import { OneOnOnePlanPurchasesTable } from "./OneOnOnePlanPurchasesTable.tsx";
import { LoadingRows } from "../UI/Loading/LoadingRows.tsx";
import { Layout } from "../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { Card } from "../UI/Card.tsx";
import { useFilterController } from "../QueryFilterUtils/useFilterController.ts";
import { useGetOneOnOnePlanPurchases } from "./useGetOneOnOnePlanPurchases.ts";
import { Select } from "@normasteaching/norma-ui";
import { useCallback } from "react";

type PurchaseFilter = Partial<{
  onboardingFormCompleted: boolean;
}>;

export const OneOnOnePlanPurchasesScreenPath = "/one-on-one-plan-purchases";

export function OneOnOnePlanPurchasesScreen() {
  const { filter, setFilter } = useFilterController<PurchaseFilter>();

  const { purchases, loading } = useGetOneOnOnePlanPurchases({
    onboardingFormCompleted: filter.onboardingFormCompleted,
  });

  const onChangeOnboardingFormCompleted = useCallback(
    (value: string | null) => {
      const onboardingFormCompleted =
        value === "true" ? true : value === "false" ? false : undefined;
      setFilter({ ...filter, onboardingFormCompleted });
    },
    [setFilter, filter],
  );

  return (
    <Layout>
      <Card>
        <ScreenTitleBlock title={"1 on 1 Plan Purchases"} />
      </Card>
      <div className={"mt-4"}>
        <Card>
          <div className={"mb-4"}>
            <Select
              placeholder={"Onboarding form completato"}
              options={[
                { name: "Sì", id: "true" },
                { name: "No", id: "false" },
              ]}
              value={
                filter.onboardingFormCompleted === true
                  ? "true"
                  : filter.onboardingFormCompleted === false
                    ? "false"
                    : undefined
              }
              onChange={onChangeOnboardingFormCompleted}
              clearable
            />
          </div>

          {loading ? (
            <LoadingRows />
          ) : (
            <OneOnOnePlanPurchasesTable purchases={purchases} />
          )}
        </Card>
      </div>
    </Layout>
  );
}
